import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { VulnerabilityOptions } from '../../Models/Models/Customer/VulnerabilityOptions';
import { VulnerabilityCategory } from '../../Constants/Enums/Customer/VulnerabilityCategory';
import { VulnerabilityType } from '../../Constants/Enums/Customer/VulnerabilityType';

declare var IS_RUNNING_IN_APP_POOL;

export class VulnerabilityOptionsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(category: VulnerabilityCategory, type: VulnerabilityType): Promise<VulnerabilityOptions, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/VulnerabilityOptions/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { category: category, type: type }

    return AjaxWrapper.get<VulnerabilityOptions, any>(url, data);
  }
}

